<div class="modal-header">
  <h4 class="modal-title">Confirmation</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (!companyActivated) {
  <div class="modal-body">Are you sure you want to perform this action?</div>
}
@if (companyActivated && !tyreDetails) {
  <div class="modal-body">Do you want to activate  {{ branchName }}?</div>
}
@if (companyActivated && tyreDetails) {
  <div class="modal-body">Are you sure you want to approve {{ tyreDetails?.tyreMake }}, {{tyreDetails?.name}}, {{tyreDetails?.tyreDetails[0]?.tyreSize}}  ?</div>
}

<div class="modal-footer button_section">
  <button type="button" class="btn pr-2" (click)="closeDialog()">
    Cancel
  </button>
  @if (acceptRejectData) {
    <button type="button" class="btn app-btn-primary" (click)="confirmation(acceptRejectData)">
      {{ acceptRejectData === 'Accept' ? 'Accept' : 'Reject'}}
      @if (isLoading) {
        <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      }
    </button>
  }
  @if (companyActivated && tyreDetails) {
    <button type="button" class="btn app-btn-primary" (click)="confirmation('isActivated')">
      Approve
      @if (isLoading) {
        <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      }
    </button>
  }
  @if (companyActivated && ! tyreDetails) {
    <button type="button" class="btn app-btn-primary" (click)="confirmation('isActivated')">
      Activate
      @if (isLoading) {
        <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      }
    </button>
  }
</div>